export const HALLIDAY_DOMAIN = "https://app.halliday.xyz";
export const HALLIDAY_API_URL = "https://api.halliday.xyz/v1/client";
export const HALLIDAY_PAYMENTS_API_URL = "https://v2.prod.halliday.xyz";

export const WIDGET_WIDTH = 480;
export const WIDGET_HEIGHT = 638;

/**
 * Regex to validate the apiDomainName
 * Only allow halliday.xyz or localhost
 */
export const API_DOMAIN_REGEX =
    /^(https:\/\/(?:[\w-]+\.)*halliday\.xyz(?:\/.*)?|http:\/\/localhost(?::\d+)?(?:\/.*)?|https:\/\/localhost(?::\d+)?(?:\/.*)?)$/;

export const UUID_REGEX = /^[0-9a-fA-F]{8}\b-[0-9a-fA-F]{4}\b-[0-9a-fA-F]{4}\b-[0-9a-fA-F]{4}\b-[0-9a-fA-F]{12}$/;
